import { Typography } from 'antd';
import React from 'react';
import {
  FormConfigProps,
  FormStempContentProps,
  contentStyling,
} from '../../constants/constants';
import { DynamicFormField } from '../DynamicFormField';

export const supportiveToolsMarked: Record<string, FormConfigProps> = {
  computerTablet: {
    label: 'kompiuteris / planšetė',
    value: 'computerTablet',
  },
  speechToTextSoftware: {
    label: 'programinė funkcija, keičianti šnekamąją kalbą į tekstą',
    value: 'speechToTextSoftware',
  },
  audioTaskTools: {
    label: 'užduočių, tekstų įgarsinimo priemonė:',
    value: 'audioTaskTools',
    children: {
      dictaphone: {
        label: 'diktofonas',
        value: 'dictaphone',
        paddingLeft: 24,
      },
      textToSpeechSoftware: {
        label: 'programinė funkcija, įgarsinanti tekstą',
        value: 'textToSpeechSoftware',
        paddingLeft: 24,
      },
      smartReadingPen: {
        label: 'išmanusis skaitantis rašiklis',
        value: 'smartReadingPen',
        paddingLeft: 24,
      },
      recordingDevice: {
        label: 'įrašanti ir įrašą įgarsinanti priemonė',
        value: 'recordingDevice',
        paddingLeft: 24,
      },
      audioTaskToolsOther: {
        label: 'kita:',
        value: 'audioTaskToolsOther',
        isInput: true,
        paddingLeft: 24,
      },
    },
  },
  personalHeadphones: {
    label: 'asmeninės ausinės garso įrašams klausyti',
    value: 'personalHeadphones',
  },
  readingRuler: {
    label: 'skaitymo liniuotė',
    value: 'readingRuler',
  },
  coloredPageFilters: {
    label: 'spalvoti lapų filtrai',
    value: 'coloredPageFilters',
  },
  pastelNotebooks: {
    label: 'sąsiuviniai pastelinių spalvų lapais',
    value: 'pastelNotebooks',
  },
  boldLineNotebooks: {
    label: 'sąsiuviniai paryškintomis linijomis',
    value: 'boldLineNotebooks',
  },
  rulesFormulasSets: {
    label: 'taisyklių / formulių rinkiniai',
    value: 'rulesFormulasSets',
  },
  calculator: {
    label: 'skaičiuotuvas',
    value: 'calculator',
  },
  penPencilHolders: {
    label: 'rašiklio / pieštuko laikikliai',
    value: 'penPencilHolders',
  },
  noiseCancelingHeadphones: {
    label: 'garsą slopinančios ausinės',
    value: 'noiseCancelingHeadphones',
  },
  visualInstructions: {
    label: 'pamokos veiklų eigos vizualinės instrukcijos',
    value: 'visualInstructions',
  },
  other: {
    label: 'kita:',
    value: 'other',
    isInput: true,
  },
};

export const Block62 = React.memo(
  ({ form, currentStep }: FormStempContentProps) => {
    return (
      <div
        style={{
          ...contentStyling,
          display: currentStep === 10 ? 'block' : 'none',
        }}
      >
        <Typography.Title
          style={{ marginTop: 0, marginBottom: 34, fontWeight: 'normal' }}
          level={4}
        >
          Specialiosios mokymo priemonės:
        </Typography.Title>
        <DynamicFormField
          formItemConfig={supportiveToolsMarked}
          formPathParams={['subject', 'block6', 'tools']}
          form={form}
        />
      </div>
    );
  },
);
